import { Typography } from '@mui/material';

export interface CustomDescriptionProps {
  description: string;
}

export const CustomDescription = ({ description }: CustomDescriptionProps) => {
  return (
    <Typography variant="body2">
      <span dangerouslySetInnerHTML={{ __html: description }} />
    </Typography>
  );
};
